import axios from "../axiosInstance"
import { listarConvenioPorLab } from "../shared/utils/Endpoints"

class ConvenioService {
    async listarConvenioPorLaboratorio(codLaboratorio) {
        return await axios.get(listarConvenioPorLab.replace("{codigoLaboratorio}", codLaboratorio));
    }
}

export default new ConvenioService();